import React from "react";

const Impact = () => {
  return (
    <div className="impact">
      <a href="#">Read Tesla's 2021 Impact Report</a>
    </div>
  );
};

export default Impact;
